import * as DOM from '../services/dom.ts';
import {scrollAndHighlightElement} from '../services/util.ts';
import {Component} from './component';
import mermaid from 'mermaid';

function toggleAnchorHighlighting(elementId, shouldHighlight) {
    DOM.forEach(`#page-navigation a[href="#${elementId}"]`, anchor => {
        anchor.closest('li').classList.toggle('current-heading', shouldHighlight);
    });
}

function headingVisibilityChange(entries) {
    for (const entry of entries) {
        const isVisible = (entry.intersectionRatio === 1);
        toggleAnchorHighlighting(entry.target.id, isVisible);
    }
}

function addNavObserver(headings) {
    // Setup the intersection observer.
    const intersectOpts = {
        rootMargin: '0px 0px 0px 0px',
        threshold: 1.0,
    };
    const pageNavObserver = new IntersectionObserver(headingVisibilityChange, intersectOpts);

    // observe each heading
    for (const heading of headings) {
        pageNavObserver.observe(heading);
    }
}

export class PageDisplay extends Component {

    setup() {
        this.container = this.$el;
        this.pageId = this.$opts.pageId;

        window.importVersioned('code').then(Code=>{
            // Code.highlight();
            // 미리보기 렌더링 제어를 위한 startOnLoad false
            mermaid.initialize({
                startOnLoad: false,
                securityLevel: 'loose',
                theme: 'base',
                themeVariables: {
                    primaryColor: '#F7F0EB',
                    primaryTextColor: '#3D2B1F',
                    primaryBorderColor: '#8B7668',
                    secondaryColor: '#EBF0F5',
                    secondaryTextColor: '#2C3E50',
                    secondaryBorderColor: '#5A7A94',
                    tertiaryColor: '#F5F2EE',
                    tertiaryTextColor: '#4A4540',
                    tertiaryBorderColor: '#9E958B',
                    lineColor: '#5C5552',
                    textColor: '#3D2B1F',
                    mainBkg: '#F7F0EB',
                    nodeBorder: '#8B7668',
                    fontFamily: 'sans-serif',
                    fontSize: '14px',
                },
                flowchart: {
                    htmlLabels: true,
                    curve: 'linear',
                    padding: 16,
                    nodeSpacing: 50,
                    rankSpacing: 60,
                    useMaxWidth: true,
                },
                sequence: {
                    mirrorActors: false,
                    messageMargin: 40,
                    boxMargin: 10,
                    noteMargin: 10,
                },
            });
            this.renderMermaid();
        });
        this.setupNavHighlighting();

        // Check the hash on load
        if (window.location.hash) {
            const text = window.location.hash.replace(/%20/g, ' ').substring(1);
            this.goToText(text);
        }

        // Sidebar page nav click event
        const sidebarPageNav = document.querySelector('.sidebar-page-nav');
        if (sidebarPageNav) {
            DOM.onChildEvent(sidebarPageNav, 'a', 'click', (event, child) => {
                event.preventDefault();
                window.$components.first('tri-layout').showContent();
                const contentId = child.getAttribute('href').substr(1);
                this.goToText(contentId);
                window.history.pushState(null, null, `#${contentId}`);
            });
        }
    }

    goToText(text) {
        const idElem = document.getElementById(text);

        DOM.forEach('.page-content [data-highlighted]', elem => {
            elem.removeAttribute('data-highlighted');
            elem.style.backgroundColor = null;
        });

        if (idElem !== null) {
            scrollAndHighlightElement(idElem);
        } else {
            const textElem = DOM.findText('.page-content > div > *', text);
            if (textElem) {
                scrollAndHighlightElement(textElem);
            }
        }
    }

    setupNavHighlighting() {
        const pageNav = document.querySelector('.sidebar-page-nav');

        // fetch all the headings.
        const headings = document.querySelector('.page-content').querySelectorAll('h1, h2, h3, h4, h5, h6');
        // if headings are present, add observers.
        if (headings.length > 0 && pageNav !== null) {
            addNavObserver(headings);
        }
    }

    async renderMermaid() {
        const blocks = this.container.querySelectorAll('pre code.language-mermaid');
        for (const block of blocks) {
            const pre = block.parentElement;
            const code = block.innerText.trim();
            if (!code) continue;
            const id = 'mermaid-' + Math.random().toString(36).slice(2);
            try {
                const { svg } = await mermaid.render(id, code);
                const div = document.createElement('div');
                div.innerHTML = svg;
                pre.replaceWith(div);
            } catch(e) {
                // 실패 시 pre code 그대로 유지 (PDF와 동일)
                const errEl = document.getElementById(id);
                if (errEl) errEl.remove();
            }
        }
    }

}
